import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import Sidebar from '@vb/components/Sidebar'
import SupportChat from '@vb/components/SupportChat'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
  isAuthTopbar: settings.isAuthTopbar,
  menuColor: settings.menuColor,
})

const AuthLayout = ({
  children,
  // menuColor,
  // isGrayTopbar,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
  // isAuthTopbar,
}) => {
  return (
    <Layout className="vb__layout">
      <Layout.Content>
        <Sidebar />
        <SupportChat />
        <div
          className={classNames(`${style.container}`, {
            vb__layout__squaredBorders: isSquaredBorders,
            vb__layout__cardsShadow: isCardShadow,
            vb__layout__borderless: isBorderless,
            [style.white]: authPagesColor === 'white',
            [style.gray]: authPagesColor === 'gray',
          })}
          style={{
            backgroundImage:
              authPagesColor === 'image' ? 'url(resources/images/content/photos/8.jpeg)' : '',
          }}
        >
          <div className="flex flex-col w-full" style={{ height: '75vh' }}>
            <div className="mb-0">{children}</div>
            {/* <div className="mt-auto absolute pb-0 pr-0"> */}
            {/* <div className="fixed bottom-0 right-0 p-4"> */}
            {/* <div className="text-center">
              <p className="mb-0">
                Copyright © {new Date().getFullYear()}{' '}
                <a href="https://squareboat.com/" target="_blank" rel="noopener noreferrer">
                  Squareboat.com
                </a>
              </p>
            </div> */}
            {/* <div className="fixed bottom-0 right-0 p-4">
              <img
                src="https://cdn.squareboat.com/img_large_webp/sb-assets/svg/Logo-text.svg"
                alt="Squareboat Image"
                height={50}
                width={200}
              />
            </div> */}
            {/* </div> */}
            {/* Footer logo aligned bottom-right inside layout */}
          </div>
          <div style={{ backgroundColor: '#e5f2fd', width: '100vw', height: '30vh' }}>
            <div
              style={{
                position: 'fixed', // or 'absolute' if parent is relative
                bottom: 5,
                right: 15,
                padding: '10px', // optional spacing from edges
                textAlign: 'right', // aligns text inside to right
              }}
            >
              <p style={{ margin: 0 }}>Powered by</p>
              <a href="https://www.squareboat.com" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://cdn.squareboat.com/img_large_webp/sb-assets/svg/Logo-text.svg"
                  alt="Squareboat Logo"
                  height={30}
                  width={150}
                />
              </a>
            </div>
          </div>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connect(mapStateToProps)(AuthLayout))
